module.exports = __webpack_public_path__ + "mobile/img/img_about_us.3542f181.png";